import SBox from 'components/opinionless/SBox'
import React, { useContext, useEffect, useState } from 'react'
import { SStyled } from 'styles/theme'
import { ga4_useTitle } from 'utils/ga4'

import { StepWizardChildProps } from 'react-step-wizard'

import DocumentsProofOfHouseholdIncomeStep1 from './DocumentsProofOfHouseholdIncomeStep1'
import DocumentsProofOfHouseholdIncomeStep2 from './DocumentsProofOfHouseholdIncomeStep2'
import { ApplicationContext } from 'v2/context/application'
import { useApplicationAnswers } from '../../../../v2/hooks/useApplicationAnswers'

interface Props {
    setCurrentStep?: (number) => void
    fontFamily: any
    nextStep?: any
    onPrevious?: any
    onSuccess?: any
    updatePercentage: any
    requestedNewDocument?: string
    fromBackButton?: boolean
}

export const Container = SStyled(SBox)`
    width: 100%;
    max-width: 600px;
`

const DocumentsProofOfHouseholdIncome: React.FC<Props> = (props: Props & StepWizardChildProps) => {
    const [currentStep, setCurrentStep] = useState(props.fromBackButton ? 2 : 1)
    const [selectedDocument, setSelectedDocument] = useState('')
    const [selectedMember, setSelectedMember] = useState(null)
    const applicationContext = useContext(ApplicationContext)
    const { getAnswersByCategory } = useApplicationAnswers()

    ga4_useTitle('Household_income')

    const fontFamily = props.fontFamily

    useEffect(() => {
        if (!selectedDocument) {
            const contextSelectedDocument = getAnswersByCategory('PROOF_OF_INCOME_CATEGORY')?.[0]
            if (contextSelectedDocument) {
                setSelectedDocument(contextSelectedDocument.response)
            }
        }
    }, [applicationContext.answers])

    useEffect(() => {
        if (
            props.requestedNewDocument &&
            applicationContext.householdMembers.length > 0 &&
            currentStep === 1 &&
            applicationContext.profile?.firstName
        ) {
            const query = new URLSearchParams(window.location.search)
            const memberId = query.get('member')
            const personId = atob(memberId).split(':')[1]
            const selectedHouseholdMember = applicationContext.householdMembers?.filter((member) => {
                return member.id === personId
            })

            if (selectedHouseholdMember.length === 0) {
                setSelectedMember(applicationContext.profile)
                if (!query.get('type')) {
                    setCurrentStep(2)
                }
            } else {
                setSelectedMember(selectedHouseholdMember[0])
            }
        }
    }, [props.requestedNewDocument, applicationContext.householdMembers, applicationContext.profile])

    return (
        <div>
            {currentStep === 1 && (
                <DocumentsProofOfHouseholdIncomeStep1
                    setSelectedMember={setSelectedMember}
                    onPrevious={props.onPrevious}
                    nextStep={() => setCurrentStep(2)}
                    fontFamily={fontFamily}
                    updatePercentage={props.updatePercentage}
                    setSelectedDocument={setSelectedDocument}
                    disableBackButton={!!props.requestedNewDocument}
                />
            )}
            {currentStep === 2 && (
                <DocumentsProofOfHouseholdIncomeStep2
                    selectedMember={selectedMember}
                    onPrevious={() => setCurrentStep(1)}
                    selectedDocument={selectedDocument}
                    nextStep={() => setCurrentStep(3)}
                    fontFamily={fontFamily}
                    onSuccess={props.onSuccess}
                    updatePercentage={props.updatePercentage}
                />
            )}
        </div>
    )
}

export default DocumentsProofOfHouseholdIncome
